import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Observable, catchError, map, of } from 'rxjs';

import { AuthStateService } from '../service/auth-state.service';
import { ReturnUrlService } from '../service/return-url.service';

export const TWO_FACTOR_SETUP_PATH = '/auth/two-factor-setup';

export const twoFactorSetupGuard: CanActivateFn = (
  _route,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const authState = inject(AuthStateService);
  const returnUrl = inject(ReturnUrlService);
  const router = inject(Router);

  return authState.ensureLoaded().pipe(
    map(() => decide(authState, returnUrl, router, state.url)),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};

function decide(
  authState: AuthStateService,
  returnUrl: ReturnUrlService,
  router: Router,
  url: string,
): boolean | UrlTree {
  const setupRequired = authState.twoFactorSetupRequired();
  const codesPending = authState.recoveryCodesPending();
  const enrolled = authState.user()?.twoFactorEnabled === true;
  const isSetupRoute = url.startsWith(TWO_FACTOR_SETUP_PATH);

  if ((setupRequired || codesPending) && !isSetupRoute) {
    returnUrl.remember(url);

    return router.createUrlTree([TWO_FACTOR_SETUP_PATH]);
  }
  if (!setupRequired && !codesPending && isSetupRoute && enrolled) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
}
